import { useState, useEffect } from 'react'

import { useMe } from '../contexts/me'

interface IRemote {
  load: () => Promise<any>
}

export const useFetchContracts = <T>(remote: IRemote) => {
  const { me } = useMe()

  const [contracts, setContracts] = useState<T[]>([])

  useEffect(() => {
    const fetchContracts = async () => {
      if (me) {
        const res = await remote.load()
        setContracts(res)
      }
    }

    fetchContracts()
  }, [me])

  return { contracts }
}
